module.exports = __webpack_public_path__ + "static/media/xiuguluanshan7.56099b6d.webp";